import { Dashboard } from '../components/dashboard/Dashboard';
import { ReactElement } from 'react';

export const DashboardPage = (): ReactElement => {
  return <Dashboard />;
};
